import { trpc } from "@mnk/frontend/lib/trpc";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Header } from "./Header";

export const BaseLayout = () => {
  const navigate = useNavigate();
  const getAuthed = trpc.authed.useQuery();

  useEffect(() => {
    if (!getAuthed.isLoading) {
      const authed = getAuthed.data;
      if (!authed) {
        navigate("/login");
      }
    }
  }, [getAuthed.isLoading, getAuthed.data, navigate]);

  if (getAuthed.isLoading || !getAuthed.data) return null;

  return (
    <div className="flex flex-col h-screen">
      <Header />
      <main className="flex-1 mt-14">
        <Outlet />
      </main>
    </div>
  );
};
